import { resourcesLanguageEnglish as raguResourcesLanguageEnglish } from '@ragu-components/ord-providers';

import { adminResourcesLanguageEnglish } from './adminResources';
import { assignedResourcesLanguageEnglish } from './assignedResources';
import { calendarsLanguageEnglish } from './calendars';
import { rolesLanguageEnglish } from './roles';
import { serviceClassesLanguageEnglish } from './serviceClasses';
import { servicesResourcesLanguageEnglish } from './servicesResources';
import { systemResourcesLanguageEnglish } from './systemResources';
import { userResourcesLanguageEnglish } from './userResources/userResourcesLanguageEnglish';

import type { ResourcesTranlationMessages } from './resourcesTranslationMessages';

export const resourcesLanguageEnglish: ResourcesTranlationMessages = {
  resources: {
    ...raguResourcesLanguageEnglish,
    ...calendarsLanguageEnglish,
    ...adminResourcesLanguageEnglish,
    ...userResourcesLanguageEnglish,
    ...servicesResourcesLanguageEnglish,
    ...serviceClassesLanguageEnglish,
    ...assignedResourcesLanguageEnglish,
    ...systemResourcesLanguageEnglish,
    ...rolesLanguageEnglish,
  },
};
